import Cart from './cart'
import Account from './account'
import Contact from './contact'
import Quiz from './quiz'
import Categories from './categories'
import Auth from './auth'
import WishListShare from './wishlistshare'

export default {
    ...Cart,
    ...Account,
    ...Contact,
    ...Quiz,
    ...Categories,
    ...Auth,
    ...WishListShare,
}
